import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('schemaUsage');
const type = createActionType('schemaUsage');

export const OPEN_DIALOG = type('OpenDialog');
export const CLOSE_DIALOG = type('CloseDialog');
export const ANALYZE_SCHEMA_USAGE = apiType('AnalyzeSchemaUsage');
export const SHOW_ANALAYZE_SCHEMA_USAGE_SUCCESS_NOTIFICATION = type(
    'ShowAnalyzeSchemaSuccessNotification'
);
export const SHOW_ANALAYZE_SCHEMA_USAGE_FAILURE_NOTIFICATION = type(
    'ShowAnalyzeSchemaFailureNotification'
);
